/**
 * Quando a saude vira alerta.
 *
 * Estes dois numeros estavam escritos tres vezes: com nome em
 * `vigia.service.ts`, e magicos em `admin-saude.controller.ts` e na tela de
 * saude. Divergir era so questao de tempo — e a divergencia teria a forma pior
 * possivel: a tela pintando de ambar sem alerta nenhum ter saido, ou o
 * contrario.
 */
export const LIMIARES_SAUDE = {
  /** Acima disto o disco entra como alerta. */
  discoCheioPct: 85,
  /** Backup mais velho que isto conta como atrasado (36 h da folga a um dia perdido). */
  backupAtrasadoMs: 36 * 60 * 60 * 1000,
  /**
   * O cerebro (F14) ingere de hora em hora; 3 h da folga a um ciclo perdido
   * sem virar alarme por uma unica falha isolada.
   */
  ingestaoAtrasadaMs: 3 * 60 * 60 * 1000,
  /**
   * Cota de motor mais velha que isto conta como SEM LEITURA no painel.
   *
   * Janela bem maior que `IDADE_MAXIMA_DA_COTA_MIN` (2 h, em `sugestao.ts`), e
   * de proposito: la a pergunta e "da para decidir com este numero?", aqui e
   * "esta maquina parou de reportar?". A cota do Codex chega EMPURRADA durante
   * um turno, nunca por consulta — uma maquina que nao rodou nada em duas
   * horas esta saudavel e sem numero novo, e alarmar por isso ensinaria a
   * ignorar o alarme.
   */
  cotaSemLeituraMs: 6 * 60 * 60 * 1000,
} as const;
